// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Cn from "re-classnames/src/Cn.bs.js";
import * as React from "react";
import * as TestUtils from "../helpers/TestUtils.bs.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";

require("./Pill.css");

function Pill(Props) {
  var testID = Props.testID;
  var className = Props.className;
  var style = Props.style;
  var label = Props.label;
  var value = Props.value;
  var className$1 = Cn.make(/* :: */[
        "hui_pill",
        /* :: */[
          Cn.unpack(className),
          /* [] */0
        ]
      ]);
  var label$1 = label !== undefined ? React.createElement("div", {
          className: "label"
        }, React.createElement("div", {
              className: "text"
            }, label)) : null;
  var value$1 = value !== undefined ? React.createElement("div", {
          className: "value"
        }, React.createElement("div", {
              className: "text"
            }, value)) : null;
  var tmp = {
    className: className$1
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  var div = React.createElement("div", tmp, label$1, value$1);
  return TestUtils.withTestID(Caml_option.some(testID), div);
}

var make = Pill;

var $$default = Pill;

export {
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
